// noinspection JSNonASCIINames,NonAsciiCharacters

import {invoiceTranslations} from "./invoice";
import {employeeTranslations} from "./employee";
import {currencyTranslations} from "./currency";
import {companySettingsTranslations} from "./company_settings";

export const ruTranslations = {
    common: {
        back: "Назад",
        next: "Далее",
        open: "Откр.",
        close: "Закрыть",
        clear: "Очистить",
        delete_short: "Удал.",
        delete: "Удалить",
        send: "Отправить",
        save: "Сохранить",
        add: "Добавить",
        cancel: "Отменить",
        preview: "Предпросмотр",
        are_you_sure: "Вы уверенны?",
        dropzone: "Перетяните сюда файл или просто нажмите",
        upload: "Загрузить",
        notify: "Уведомить",
        here: "здесь",
        yes: "Да",
        no: "Нет",
        uom: {
            "months": "месяцы",
            "pcs": "шт.",
            "hours": "часы",
            "km": "км.",
            "kg": "кг.",
            "m³": "м³",
            "m²": "м²",
            "ltr": "литры",
            "N/A": "Н/Д",
        },
        article: {
            "Sale of goods in Estonia or non EU": "Продажа товаров в Эстонии или за пред. ЕС",
            "Sale of services in Estonia or non EU": "Продажа услуг в Эстонии или за пред. ЕС",
            "Sale of goods in Estonia or non EU after 01.07.2025": "Продажа товаров в Эстонии или за пред. ЕС после 01.07.2025",
            "Sale of services in Estonia or non EU after 01.07.2025": "Продажа услуг в Эстонии или за пред. ЕС после 01.07.2025",
            "Sale of goods in the EU 0%": "Продажа товара в ЕС 0%",
            "Sale of services in the EU 0%": "Продажа услуг в ЕС 0%",
            "Export of goods from Estonia": "Экспорт товаров из Эстонии",
            "select_correct_article": "Пожалуйста, выберите правильную статью",
        },
        tax: {},
        error: {
            required_field: "Обязательное поле",
            invalid_email: "Неправильный адрес эл. почты",
            invalid_email_with_address: "'{{email}}' не правильный адресс эл. почты",
            should_be_greater_that_zero: "Должно быть больше нуля",
        }
    },
    user_menu: {
        "Subscription": "Подписка",
        "Language": "Язык/Lang",
        "Logout": "Выйти",
        "CompanySettings": "Настройки компании",
    },
    nav_bar: {
        company_selector: "Выберите компанию",
        "Upload docs": "Загр. док-ты",
        "Sales": "Продажи",
        "New invoice": "Новый инвойс",
        "My sales": "Мои продажи",
        "My clients": "Мои клиенты",
        "My company": "Моя комп-я",
        "Details": "Подробности",
        "Advice": "Совет",
        "Knowledge base": "База знаний",
        "Employees": "Работники",
        "New employee": "Новый работник",
        "Links": "Ссылки",
        "Templates": "Шаблоны",
    },
    documents: {
        upload: {
            time_frame: "Период",
            time_frame_hint: "Пожалуйста, выберете месяц и год за который вы загружаете документы",
            files: {
                header: "Файлы",
                title: "Пожалуйста, загрузите следующие документы:",
                sales_invoices: "Инвойсы на продажу в <1>PDF</1> формате, если вы не используете наш генератор инвойсов",
                purchase_invoices: "Инвойсы на покупку и чеки в <1>PDF</1> формате",
                statements: "Банковские выписки, <1>если вы не предоставили нам доступ</1>",
                statements_est_banks: "в формате <1><2>XML</2></1> и <3><4>PDF</4></3>, если вы используете сервисы Эстонских банков",
                statements_other_banks: "в формате <1><2>CSV</2></1> и <3><4>PDF</4></3>, если вы используете TransferWise, EuroWallet, Revolut, PaySera, PayPal или другие платежные системы",
            },
            review: {
                header: "Обзор",
                period_summary: "Я загружаю документы за",
                rejected_documents: "Документы, которые не будут загружены:",
                documents_to_upload: "Список документов:",
                comment_label: "Комментарий для бухгалтера (не обязательно)",
                comment_placeholder: "Пожалуйста, оставьте комментарий, касающийся документов, которые вы загружаете",
            },
            upload: {
                header: "Загрузка",
                success: "Все файлы были загружены!",
                error: "Не удалось загрузить файл, пожалуйста обратитесь в поддержку!",
            }
        }
    },
    loader_screen: {
        select_company: "Пожалуйста, сначала выберите компанию",
        no_company_assigned: "Ни одна компания не привязана к вашему аккаунту",
        no_company_action: "Если у вас есть вопросы, касательно наших сервисов - пожалуйста используйте кнопку чата в правом углу и мы свяжемся с вами при первой возможности",
    },
    advice: {
        use_chat: "Если у вас есть какие-либо вопросы - пожалуйста используйте кнопку чата в правом углу",
    },
    my_company_info: {
        header: "Общая информация о вашей компании",
        "Company name": "Название компании",
        "Reg. code": "Рег. код",
        "VAT number": "НДС номер",
        "Legal address": "Юридический адрес",
        "mailbox_address_note": "Если вы хотите получать корреспонденцию на имя вашей компании - пожалуйста, используйте почтовый адрес ниже",
        "Mailbox address": "Почтовый адрес",
    },
    knowledge_base: {
        header: "База знаний",
        sub_header: "Мы приготовили для вас широкий список статей, которые описывают разнообразные аспекты бухгалтерии в Эстонии",
        visit_knowledge_base: "Если у вас есть вопрос - пожалуйста, проверьте не ли ответа на него в нашей базе знаний",
        here: "здесь",
        link: "https://help.amsgroup.ee/ru",
        ask_advice: "Если у вас все еще остались вопросы - пожалуйста, свяжитесь с нами с помощью чата",
    },
    client_docs_templates: {
        header: "Шаблоны документов",
    },
    customers_list: {
        title: "Клиенты",
        name: "Имя",
        address: "Адрес",
        city: "Город",
        post_code: "Почтовый код",
        country: "Страна",
    },
    edit_customer: {
        edit_header: "Редактировать клиента",
        add_header: "Добавить клиента",
        name: {
            label: "Имя",
            placeholder: "Полное имя",
            helper_text: "Название компании или полное имя физ. лица",
        },
        not_td_customer: "Физическое лицо или предприятие, зарег. за пределами Эстонии",
        reg_num: {
            label: "Рег. номер",
            placeholder: "Регистрационный номер",
        },
        vat_num: {
            label: "Номер НДС",
            placeholder: "Номер НДС",
        },
        address: {
            label: "Адрес",
            placeholder: "Адрес",
            helper_text: "Строка адреса (улица, номер дома и т.д.)",
        },
        city: "Город",
        postal_code: "Индекс",
        country: "Страна",
        email: "Эл. почта",
        phone_num: "Телефон",
        currency: "Валюта",
        inv_lang: "Язык инвоса",
        payment_dead_line: {
            label: "Срок оплаты",
            placeholder: "Срок оплаты",
            helper_text: "Кол-во дней, данных клиенту для оплаты по счету",
        },
        overdue_charge: {
            label: "Проценты на задолженность",
            placeholder: "Проценты на задолженность",
            helper_text: "Проценты на просроченную задолженность",
        },
    },
    m_table: {
        "Add or remove columns": "Добавить или удалить колонки",
        "{0} row(s) selected": "Выбранно строк {0}",
        "Search": "Поиск",
        "First Page": "Первая страница",
        "Previous Page": "Предыдущая страница",
        "Next Page": "Следующая страница",
        "Last Page": "Последняя страница",
        "{from}-{to} of {count}": "{from}-{to} из {count}",
        "Rows per page": "Строк на странице",
        "rows": "строк",
        "No records to display": "Нет записей для отображения",
        "Actions": "Действия",
    },
    ...invoiceTranslations,
    ...employeeTranslations,
    ...currencyTranslations,
    ...companySettingsTranslations,
}